import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const SimilarChallengesSection = ({ currentCaseStudy, similarCases, onViewCase }) => {
  if (!similarCases || similarCases?.length === 0) return null;

  return (
    <div className="bg-surface rounded-lg p-6 mt-8">
      <div className="flex items-center space-x-3 mb-6">
        <Icon name="Lightbulb" size={24} className="text-primary" />
        <div>
          <h3 className="text-lg font-semibold text-text-primary">
            Similar Challenges We've Solved
          </h3>
          <p className="text-sm text-text-secondary">
            Explore related case studies in your industry
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {similarCases?.map((caseStudy, index) => (
          <div key={index} className="bg-white rounded-lg enterprise-border p-4 enterprise-transition hover:shadow-md group cursor-pointer"
               onClick={() => onViewCase(caseStudy)}>
            <div className="flex items-start space-x-3 mb-3">
              <div className="w-10 h-10 bg-surface rounded-lg flex items-center justify-center flex-shrink-0">
                <Image 
                  src={caseStudy?.companyLogo} 
                  alt={`${caseStudy?.company} logo`}
                  className="w-6 h-6 object-contain"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-medium text-text-primary group-hover:text-primary enterprise-transition truncate">
                  {caseStudy?.company}
                </h4>
                <p className="text-xs text-text-secondary">{caseStudy?.industry}</p>
              </div>
            </div>

            <p className="text-sm text-text-secondary mb-3 line-clamp-2">
              {caseStudy?.shortDescription}
            </p>

            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <span className="text-xs bg-primary/10 text-primary px-2 py-1 rounded-full">
                  {caseStudy?.solutionType}
                </span>
              </div>
              <div className="text-sm font-medium text-success">
                {caseStudy?.keyMetrics?.[0]?.value}
              </div>
            </div>

            {/* Similarity Indicators */}
            <div className="mt-3 pt-3 border-t border-border">
              <div className="flex items-center justify-between text-xs">
                <div className="flex items-center space-x-1 text-text-secondary">
                  <Icon name="Target" size={12} />
                  <span>Similar Challenge</span>
                </div>
                <div className="flex items-center space-x-1 text-primary">
                  <span>{caseStudy?.similarityScore}% match</span>
                  <Icon name="ArrowRight" size={12} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* CTA Section */}
      <div className="mt-6 pt-6 border-t border-border text-center">
        <h4 className="font-medium text-text-primary mb-2">
          Facing a Similar Challenge?
        </h4>
        <p className="text-sm text-text-secondary mb-4">
          Let's discuss how we can help you achieve similar results
        </p>
        <Button variant="default" iconName="MessageCircle" iconPosition="left">
          Schedule Consultation
        </Button>
      </div>
    </div>
  );
};

export default SimilarChallengesSection;